import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface VersionSelectorProps {
  version: "classic" | "essential";
  onVersionChange: (version: "classic" | "essential") => void;
}

export const VersionSelector = ({ version, onVersionChange }: VersionSelectorProps) => {
  return (
    <div className="flex justify-center w-full mb-8">
      <RadioGroup
        value={version}
        onValueChange={(v) => onVersionChange(v as "classic" | "essential")}
        className="flex gap-8"
      >
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="classic" id="classic" />
                <label
                  htmlFor="classic"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  Classic
                </label>
              </div>
            </TooltipTrigger>
            <TooltipContent className="bg-sage-50 text-sage-800 border-sage-200">
              <p className="text-sm">Full devotional with detailed teachings and extended prayer points</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="essential" id="essential" />
                <label
                  htmlFor="essential"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  Essential
                </label>
              </div>
            </TooltipTrigger>
            <TooltipContent className="bg-sage-50 text-sage-800 border-sage-200">
              <p className="text-sm">Condensed version focusing on key message and core prayers</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </RadioGroup>
    </div>
  );
};